// src/pages/Dashboard.jsx
import React from "react";
import { useSelector } from "react-redux";
import MetricCard from "../components/MetricCard";
import KonceptSelector from "../components/KonceptSelector";
import { selectMetric } from "../slices/metricsSlice";
import "./KentyouDashboard.css";
import {
  FaWalking,
  FaCloud,
  FaWifi,
  FaRedoAlt,
  FaQuestionCircle,
  FaTint,
  FaHeartbeat,
  FaBatteryFull,
} from "react-icons/fa";

export default function Dashboard() {
  const { gatewayId, watchId } = useSelector((state) => state.selection);
  const metricsStatus = useSelector((state) => state.metrics.status);

  // Helper to grab { value, timestamp } for a given konzeptId + kapabilityId
  function useMetric(konzeptId, kapabilityId) {
    const entry = useSelector((state) =>
      selectMetric(state, konzeptId, kapabilityId)
    );
    return entry || { value: null, timestamp: null };
  }

  // Gateway values
  const { value: uptime, timestamp: uptimeTs } = useMetric(
    gatewayId,
    "StatusPRM~uptime"
  );
  const { value: wifiDown, timestamp: wifiDownTs } = useMetric(
    gatewayId,
    "StatusSTS~wifidowntime"
  );
  const { value: bootcount, timestamp: bootcountTs } = useMetric(
    gatewayId,
    "StatusPRM~bootcount"
  );
  const { value: restartReason, timestamp: restartReasonTs } = useMetric(
    gatewayId,
    "StatusPRM~restartreason"
  );

  // Watch values
  const { value: steps, timestamp: stepsTs } = useMetric(
    watchId,
    "steps~data"
  );
  const { value: locationData, timestamp: locationTs } = useMetric(
    watchId,
    "location~data"
  );
  const { value: heartRate, timestamp: heartRateTs } = useMetric(
    watchId,
    "heartrate~data"
  );
  const { value: oxymetry, timestamp: oxymetryTs } = useMetric(
    watchId,
    "oxymetry~data"
  );
  const { value: battery, timestamp: batteryTs } = useMetric(
    watchId,
    "batterylevel~data"
  );

  return (
    <div className="kentyou-dashboard-root">
      <KonceptSelector />

      {metricsStatus === "loading" && (
        <div className="kentyou-dashboard-loading">Loading metrics…</div>
      )}
      {metricsStatus === "failed" && (
        <div className="kentyou-dashboard-error">Failed to load metrics.</div>
      )}

      {metricsStatus === "succeeded" && (
        <div className="kentyou-dashboard-grid">
          {/* First row: Watch metrics */}
          <MetricCard
            icon={<FaWalking size={24} />}
            label="Number of steps"
            value={steps}
            unit=""
            lastUpdate={stepsTs}
          />
          <MetricCard
            icon={<FaTint size={24} />}
            label="Oxymetry"
            value={oxymetry}
            unit="%"
            lastUpdate={oxymetryTs}
          />
          <MetricCard
            icon={<FaHeartbeat size={24} />}
            label="Heart rate"
            value={heartRate}
            unit="beats"
            lastUpdate={heartRateTs}
          />

          {/* Second row: Watch battery + Gateway uptime */}
          <MetricCard
            icon={<FaBatteryFull size={24} />}
            label="Battery level"
            value={battery}
            unit="%"
            lastUpdate={batteryTs}
          />
          <MetricCard
            icon={<FaCloud size={24} />}
            label="System Uptime (UTC)"
            value={uptime}
            unit=""
            lastUpdate={uptimeTs}
          />
          <MetricCard
            icon={<FaWifi size={24} />}
            label="WiFi Downtime"
            value={wifiDown}
            unit=""
            lastUpdate={wifiDownTs}
          />

          {/* Third row: Gateway reboots + last restart reason */}
          <MetricCard
            icon={<FaRedoAlt size={24} />}
            label="Number of reboots"
            value={bootcount}
            unit=""
            lastUpdate={bootcountTs}
          />
          <MetricCard
            icon={<FaQuestionCircle size={24} />}
            label="Reason of last restart"
            value={restartReason}
            unit=""
            lastUpdate={restartReasonTs}
          />

          {/* Fourth “card” slot: show latest location coords (optional) */}
          <MetricCard
            icon={<FaQuestionCircle size={24} />}
            label="Latest Location"
            value={
              locationData
                ? `${locationData.latitude?.toFixed(6)}, ${locationData.longitude?.toFixed(6)}`
                : "—"
            }
            unit=""
            lastUpdate={locationTs}
          />
        </div>
      )}
    </div>
  );
}
